<template>
  <v-form ref="form" v-model="formValid">
    <v-container
      fluid
      class="d-flex flex-wrap flex-md-nowrap flex-lg-nowrap form-page-gutter stock-form-page"
    >
      <v-container fluid class="pa-0 stock-products-panel">
        <v-card class="rounded-xl" elevation="0">
          <v-card-title class="stock-form-header">
            <div class="stock-form-title">
              <span v-if="isUpdating">Stock Detail</span>
              <span v-else>New Stock</span>
            </div>
            <div class="stock-form-actions">
              <v-btn
                v-if="!isUpdating"
                rounded
                depressed
                color="primary"
                @click="addStockGroup"
                :loading="isCompletedLoading"
                :disabled="!formValid || stocks.length == 0"
                ><i class="fas fa-paper-plane mr-1"></i>Submit</v-btn
              >
              <template v-else>
                <v-btn
                  rounded
                  icon
                  color="error"
                  @click="deleteStock"
                  :loading="isDeleteLoading"
                  ><i class="fas fa-trash-can"></i
                ></v-btn>
                <v-btn
                  rounded
                  depressed
                  color="primary"
                  @click="updateStock"
                  :loading="isCompletedLoading"
                  :disabled="!formValid || stocks.length == 0"
                  ><i class="fas fa-check mr-1"></i>Update</v-btn
                >
              </template>
            </div>
          </v-card-title>
          <v-card-text class="pt-0">
            <div class="stock-product-picker">
              <v-autocomplete
                rounded
                dense
                outlined
                hide-details
                return-object
                label="Products"
                :items="products"
                item-value="id"
                item-text="title"
                v-model="selectedProduct"
              >
                <template v-slot:item="{ item }">
                  <div class="d-flex align-center" style="gap: 5px">
                    <div>
                      <img
                        :src="getProductPictureUrlById(item.pictureId)"
                        width="50px"
                        height="50px"
                      />
                    </div>
                    <div class="text-caption text-truncate">
                      {{ item.title.substr(0, 15) }}
                    </div>
                  </div>
                </template>
                <template v-slot:selection="{ item }">
                  <div class="d-flex align-center" style="gap: 5px">
                    <div>
                      <img
                        :src="getProductPictureUrlById(item.pictureId)"
                        width="50px"
                        height="50px"
                      />
                    </div>
                    <div class="text-caption text-truncate">
                      {{ item.title.substr(0, 15) }}
                    </div>
                  </div>
                </template>
              </v-autocomplete>

              <v-btn
                color="primary"
                icon
                rounded
                @click="addProductToStock"
                :disabled="!selectedProduct"
                ><i class="fas fa-plus"></i></v-btn
              >
            </div>
          </v-card-text>
          <v-card-text>
            <v-data-table
              mobile-breakpoint="0"
              :headers="headers"
              :items="stocks"
              :items-per-page="-1"
            >
              <template v-slot:[`item.pictureId`]="{ item }">
                <img
                  :src="getProductPictureUrlById(item.pictureId)"
                  width="50px"
                  height="50px"
                />
              </template>
              <template v-slot:[`item.quantity`]="{ item }">
                <v-text-field
                  :rules="[(v) => v > 0 || '']"
                  outlined
                  rounded
                  dense
                  hide-details
                  label="Quantity"
                  v-model.number="item.quantity"
                ></v-text-field>
              </template>
              <template v-slot:[`item.unitPrice`]="{ item }">
                <v-text-field
                  :rules="[(v) => v > 0 || '']"
                  outlined
                  rounded
                  dense
                  hide-details
                  label="Unit Price"
                  v-model="item.stockPrice"
                ></v-text-field>
              </template>
              <template v-slot:[`item.expDate`]="{ item }">
                <date-picker
                  hide-details
                  label="Exp Date"
                  v-model="item.expDate"
                >
                </date-picker>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  icon
                  rounded
                  color="error"
                  @click="removeSelectedProductFromStock(item.productId)"
                  ><i class="fas fa-trash-can"></i
                ></v-btn>
              </template>
              ></v-data-table
            >
          </v-card-text>
        </v-card>
      </v-container>
      <v-container fluid class="pa-0 stock-summary-panel">
        <v-card class="rounded-xl" elevation="0">
          <v-card-title>
            <v-container>
              <div class="mb-2">
                <date-picker
                  :rules="[(v) => !!v || '']"
                  label="Date Purchased"
                  v-model="datePurchased"
                ></date-picker>
              </div>

              <v-autocomplete
                :rules="[(v) => !!v || '']"
                rounded
                outlined
                dense
                hide-details
                label="Vendor"
                item-value="id"
                :items="vendors"
                :item-text="getVendorName"
                v-model="stockGroup.vendorId"
              >
                <template v-slot:no-data>
                  <v-card elevation="0">
                    <v-card-text class="text-center">
                      <h4 class="mb-2">Vendor Not Found</h4>
                      <v-btn
                        depressed
                        small
                        rounded
                        color="primary"
                        @click="
                          () => {
                            vendorDialog = !vendorDialog;
                          }
                        "
                      >
                        <i class="fas fa-plus mr-2"></i>
                        New Vendor
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </template></v-autocomplete
              >
            </v-container>
          </v-card-title>
          <v-card-text>
            <v-container class="d-flex justify-space-between"
              ><div>Total Qty</div>

              <div>{{ totalQuantity }}</div></v-container
            >
            <v-container class="d-flex justify-space-between"
              ><div>Total Amount</div>

              <div>
                <span class="mr-1">{{ currencySymbol }}</span
                ><span>{{
                  convertToCleanNumber(subtotal, currencySymbol == "$")
                }}</span>
              </div></v-container
            >
          </v-card-text>
        </v-card>
      </v-container>
    </v-container>
    <vendor-dialog v-model="vendorDialog"></vendor-dialog>
  </v-form>
</template>
<script>
import DatePicker from "@/components/DatePicker.vue";
import generalMixin from "@/js/general-mixin";
import backendService from "@/services/backend-service";
import VendorDialog from "@/components/VendorDialog.vue";
import { PaymentStatus } from "@/js/enum.js";
export default {
  name: "StockForm",
  mixins: [generalMixin],
  components: { "vendor-dialog": VendorDialog, "date-picker": DatePicker },
  mounted: function () {
    this.getProducts();
    if (this.$route.params.id) {
      this.isUpdating = true;
      this.getStockById(this.$route.params.id);
    }
    //this.$refs.form.validate();
  },
  computed: {
    Paid() {
      return this.getIdByEnum(PaymentStatus.Paid);
    },
    // Draft() {
    //   return this.getIdByEnum(StockStatus.Draft);
    // },
    // Completed() {
    //   return this.getIdByEnum(StockStatus.Completed);
    // },
    currencySymbol() {
      return "$";
    },
    headers() {
      let headers = JSON.parse(JSON.stringify(this.defaultHeaders));
      // headers.forEach((e) => (e.text = this.lm[e.text]));
      return headers;
    },
    totalQuantity() {
      let total = 0;
      for (let i = 0; i < this.stocks.length; i++) {
        total += this.stocks[i].quantity;
      }
      return total;
    },
    subtotal() {
      let total = 0;
      for (let i = 0; i < this.stocks.length; i++) {
        total += this.stocks[i].stockPrice * this.stocks[i].quantity;
      }
      return total;
    },
    paymentStatusId() {
      return this.stockGroup.paymentStatusId;
    },
    paymentStatuses() {
      if (
        this.$store.getters["dropdownToOptions"] &&
        this.$store.getters["dropdownToOptions"]["paymentStatus"]
      )
        return this.$store.getters["dropdownToOptions"]["paymentStatus"]
          .options;
      return [];
    },
    paymentMethods() {
      if (
        this.$store.getters["dropdownToOptions"] &&
        this.$store.getters["dropdownToOptions"]["paymentMethod"]
      )
        return this.$store.getters["dropdownToOptions"]["paymentMethod"]
          .options;
      return [];
    },
  },
  data() {
    return {
      defaultHeaders: [
        { text: "Image", value: "pictureId", width: 150 },
        { text: "Title", value: "productTitle" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit Price", value: "unitPrice" },
        { text: "Exp Date", value: "expDate" },
        { text: "Action", value: "action" },
      ],
      isUpdating: false,
      isDraftLoading: false,
      isDeleteLoading: false,
      isCompletedLoading: false,
      payment: {},
      products: [],
      selectedProduct: null,
      stockGroup: {},
      oldStock: {},
      stocks: [],
      vendorDialog: false,
      formValid: false,
      datePurchased: null,
    };
  },
  methods: {
    addProductToStock() {
      let product = this.selectedProduct;
      let stock = {};
      stock.productId = product.id;
      stock.pictureId = product.pictureId;
      stock.productTitle = product.title;
      stock.quantity = 1;
      stock.stockPrice = product.stockPrice;
      let found = this.stocks.find((e) => e.productId == product.id);
      if (!found) {
        this.stocks.push(stock);
        this.selectedProduct = null;
      }
    },
    addStockGroup() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;
      this.stocks.forEach((e) => {
        e.vendorId = this.stockGroup.vendorId;
        e.datePurchased = this.datePurchased;
      });
      this.stockGroup.subtotal = this.subtotal;
      this.stockGroup.stocks = this.stocks;

      backendService.addStockGroup(this.stockGroup).then(() => {
        this.timer(1000).then(() => {
          this.isDraftLoading = false;
          this.isCompletedLoading = false;
          this.successSnackbar("Successfully added a new stock");
          this.$router.push({ name: "StockList" });
        });
      });
    },
    deleteStock() {
      this.isDeleteLoading = true;
      backendService.deleteStockById(this.stockGroup.id).then(() => {
        this.timer(1000).then(() => {
          this.isDeleteLoading = false;
          this.$router.go(-1);
        });
      });
    },
    getProducts() {
      backendService.getProducts().then((response) => {
        this.products = response.data;
      });
    },
    getProductPictureUrlById(pictureId) {
      return backendService.getProductPictureUrlById(pictureId);
    },
    getStockById(id) {
      backendService.getStockById(id).then((response) => {
        this.stockGroup = response.data;
        this.stocks = this.stockGroup.stocks;
        this.oldStock = JSON.parse(JSON.stringify(response.data));
      });
    },
    getVendorName(vendor) {
      if (!vendor) return "";
      if (vendor) {
        let toReturn = vendor.name;
        if (vendor.phone) toReturn += ` - ${vendor.phone}`;
        return toReturn;
      }
      return "";
    },
    removeSelectedProductFromStock(productId) {
      this.stocks = this.stocks.filter((e) => e.productId != productId);
    },
    updateStock() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;
      let wrappedStock = {
        oldStock: this.oldStock,
      };
      wrappedStock.newStock = this.stockGroup;
      this.stockGroup.stocks = this.stocks;
      this.stockGroup.subtotal = this.subtotal;
      backendService.updateStock(wrappedStock).then(() => {
        this.timer(1000).then(() => {
          this.isDraftLoading = false;
          this.isCompletedLoading = false;
          this.successSnackbar("Successfully updated stock");
        });
      });
    },
  },
};
</script>
<style scoped>
.stock-form-page {
  gap: 8px;
}
.stock-form-header {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
}
.stock-form-title {
  flex: 1 1 180px;
}
.stock-form-actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}
.stock-product-picker {
  align-items: center;
  display: flex;
  width: 100%;
  gap: 8px;
}
.stock-products-panel {
  flex: 1 1 0;
  min-width: 0;
}
.stock-summary-panel {
  flex: 0 0 clamp(320px, 28vw, 500px);
  max-width: 500px;
  min-width: 320px;
}
</style>
